import { getHealthRange, HealthRows } from '../api/trainer';
import { HealthResource, HealthRange } from '../api/types';

/**
 * In-memory cache of health reads, per resource and range, for the life of the page session.
 * Two requests for the same resource and range share one fetch. A failed fetch is not kept, so it can be retried.
 */
const cache = new Map<string, Promise<unknown[]>>();

export function loadHealthRange<K extends HealthResource>(resource: K, range: HealthRange): Promise<HealthRows[K][]> {
  const key = `${resource}|${range.from}|${range.to}`;
  let entry = cache.get(key);
  if (!entry) {
    entry = getHealthRange(resource, range);
    cache.set(key, entry);
    entry.catch(() => cache.delete(key));
  }
  return entry as Promise<HealthRows[K][]>;
}

/** Drops every cached read. Used by tests. */
export function clearHealthCache(): void {
  cache.clear();
}
